console.log("API_URL =", process.env.REACT_APP_API_URL);
const API_URL =
  process.env.REACT_APP_API_URL ||
  "https://us-central1-achados-67630.cloudfunctions.net/api";
async function request(path, options = {}) {
  const url = `${API_URL}${path}`;

  console.log("API REQUEST:", {
    url,
    method: options.method || "GET",
    body: options.body || null,
  });

  const res = await fetch(url, {
    method: options.method || "GET",
    headers: {
      "Content-Type": "application/json",
      ...(options.headers || {}),
    },
    body: options.body,
  });

  const rawText = await res.text();

  let data = {};
  try {
    data = rawText ? JSON.parse(rawText) : {};
  } catch {
    data = { raw: rawText };
  }

  console.log("API RESPONSE:", {
    url,
    status: res.status,
    ok: res.ok,
    data,
  });

  if (!res.ok) {
    throw new Error(
      data.error ||
        data.message ||
        data.raw ||
        `Erro HTTP ${res.status}`
    );
  }

  return data;
}

export async function fetchPostLinks() {
  return request("/post-links");
}

export async function createPostLink(payload) {
  return request("/post-links", {
    method: "POST",
    body: JSON.stringify(payload),
  });
}

export async function updatePostLink(id, payload) {
  return request(`/post-links/${id}`, {
    method: "PUT",
    body: JSON.stringify(payload),
  });
}

export async function deletePostLink(id) {
  return request(`/post-links/${id}`, {
    method: "DELETE",
  });
}